import React from "react";
import styled from "styled-components";
import ContentLoader from "react-content-loader";
function AutomationSkeleton(props) {
  const { className } = props;
  return (
    <WrapperStyle className={`${className ?? ""}`}>
      <div className="inner-wrapper">
        <div className="loader-wrapper">
          {[1, 2, 3, 4].map((item, index) => (
            <ContentLoader
              key={index}
              style={{ backgroundColor: "#FFFFFF", margin: "10px 15px", borderRadius: "10px" }}
              {...props}
            >
              <rect x="0" y="0" rx="8" ry="8" width={100 + "%"} height="89" />
            </ContentLoader>
          ))}
        </div>
      </div>
    </WrapperStyle>
  );
}

export default AutomationSkeleton;

const WrapperStyle = styled.div`
  display: flex;
  justify-content: center;
  &.list-data-loader {
    display: unset;
    align-items: unset;
  }
  .inner-wrapper {
    width: 100%;
    .loader-wrapper {
      width: calc(100% - 70px);
      /* max-height: calc(100% - 137px);
      overflow-y: auto; */
      svg {
        width: 100%;
        height: 89px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          height: 60px;
        }
      }
    }
  }
`;
